import type { Volume } from '@/entities/volume';
import request from '@/shared/api/request';

export const resizeVolume = (
  uuid: string,
  data: {
    size_gigabytes: number;
    action: string;
  },
): Promise<Volume> =>
  request({
    url: `/volumes/${uuid}/`,
    method: 'POST',
    data,
  });
